package top.wcpe.allincore.ui.runtime.render

import kotlin.jvm.JvmName

/**
 * 槽位物品视图：跨平台 SlotRenderer 看到的「槽内有什么」。
 *
 * 由平台层 [RenderContext.slotItem] 提供；fabric 实现从 ClientInventoryStore
 * 读出 wire 后转换得到。空槽（null）由调用方判断。
 *
 * 各分量经 `@get:JvmName` 保留 record 风格的裸名访问器（`itemId()` / `count()` / `nbt()`），
 * 与既有 Java 渲染器的方法式调用二进制兼容。
 *
 * @property itemId namespaced 物品 ID
 * @property count  数量
 * @property nbt    平台无关的 SNBT 字符串（携带自定义模型/贴图所需的 NBT），可为 null/空表示无 NBT
 */
data class SlotItemView(
    @get:JvmName("itemId") val itemId: String,
    @get:JvmName("count") val count: Int,
    @get:JvmName("nbt") val nbt: String?,
) {

    /** 向后兼容旧两参构造（测试与其它历史调用点仍传两参）：nbt 置 null（无 NBT）。 */
    constructor(itemId: String, count: Int) : this(itemId, count, null)
}
